<template>
  <render />
</template>
<script lang="ts" setup>
const {
  categoryManager: { category },
} = inject(INJECT_CATEGORY_PAGE);
const categoryRouterView = useCategoryRouterView(category.value);

const render = () => {
  return h(categoryRouterView);
};
</script>
